/**
 * Chat Message List
 *
 * Scrollable list of user and assistant messages
 */

import { useChatScroll } from '@/components/chat/useChatScroll';
import { ChatMessage } from './ChatMessage';

import { useTranslation } from 'react-i18next';

interface Message {
  messageId: string;
  role: 'user' | 'assistant';
  content: string;
  timestamp: string;
  toolCalls?: any[];
}

interface ChatMessageListProps {
  messages: Message[];
  onConfirmAction: (messageId: string, toolCallIndex: number, confirmed: boolean) => void;
}

export function ChatMessageList({ messages, onConfirmAction }: ChatMessageListProps) {
  const { t } = useTranslation();
  const messagesEndRef = useChatScroll([messages]);

  return (
    <div className="h-full overflow-y-auto p-6 space-y-4">
      {messages.length === 0 ? (
        <div className="flex flex-col items-center justify-center h-full text-center px-2">
          <div className="text-muted-foreground space-y-3">
            <p className="text-base font-semibold text-foreground">{t('assistant.greeting')}</p>
            <p className="text-sm">{t('assistant.intro')}</p>
            <ul className="text-sm space-y-1.5 text-left max-w-xs mx-auto">
              <li>✦ {t('assistant.services.skills')}</li>
            </ul>
            <p className="text-sm pt-2 font-medium text-foreground">
              {t('assistant.help_today')}
            </p>
          </div>
        </div>
      ) : (
        messages.map((message) => (
          <ChatMessage
            key={message.messageId}
            message={message}
            onConfirmAction={onConfirmAction}
          />
        ))
      )}
      <div ref={messagesEndRef} />
    </div>
  );
}
